
Vue.component('calc', () => import('./components/Calc/Calc.vue'));

Vue.component('product-slide', {
    template: '#product-slide-template',
    props : {
        product : {
            type : Object,
            default : {},
        },
    },
    methods: {
        changeProductsCount: function (productId, quantity) {
            if (quantity) {
                this.product.selected_cnt = quantity;
            }
            vmApp.$refs.calc.recalcTotal();
        }
    },
    mounted(){
        // $(".product_item_images").height(Math.max.apply(null,
        //     $(".product_item_images").map(function(){return $(this).height()})));
    }
});

Vue.component('products_group', {
    template: '#productsGroupComponentTemplate',
    props : {
        group : {
            type : Object,
            default : () => ({}),
        },
    },
    data : () => ({
        selectedPopupOpened : false,
    }),
    computed : {
        productsCount () {
            return _.sumBy(_.filter(this.group.products, 'selected'), product => +product.selected_cnt );
        },
        productsSum () {
            return _.sumBy(_.filter(this.group.products, 'selected'), product => +product.selected_cnt * product.PRICE ).toFixed(2);
        },
    },
    methods: {
        groupHasProducts: function () {
            var group = _.find(vmApp.$refs.calc.total.groups, group => +group.catalogGroupId == +this.group.fields.catalogGroupId);
            return group && group.products.length > 0;
        },
        showSelectedPopup () {
            this.selectedPopupOpened = true;
        },
        hideSelectedPopup () {
            this.selectedPopupOpened = false;
        },
    }
});

Vue.component('selected_popup', {
    template : '#selectedPopupComponentTemplate',
    props : {
        products : {
            type : Array,
            default : () => [],
        },
    },
    methods: {
        hide: function () {
            this.$emit('hide-selected-popup');
        },
        changeProductsCount: function () {
            if (vmApp.$refs.calc) {
                vmApp.$refs.calc.recalcTotal();
            }
        }
    },
});
